<template>
  <div id="app">
    <el-container>
      <el-header>
        <app-header></app-header>
      </el-header>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  import AppHeader from "@/components/Header"

  export default {
    name: 'App',
    components: {
      AppHeader,
    }
  }
</script>

<style lang="stylus">
  container-reset-padding()
    padding-left 0
    padding-right 0

  *
    margin 0
    padding 0

  #app
    & .el-header
      height 50px !important
      container-reset-padding()

    & .el-main
      container-reset-padding()


</style>



// WEBPACK FOOTER //
// src/App.vue